export let StepStatus;
(function (StepStatus) {
  StepStatus["Completed"] = "Completed";
  StepStatus["Pending"] = "Pending";
  StepStatus["None"] = "None";
})(StepStatus || (StepStatus = {}));